/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

import { EShapeActionOpenOpener } from "./e-shape-action-open-opener";

export const EShapeActionOpenOpeners: Record<number, EShapeActionOpenOpener> = {};
